import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Photo = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: style.fontSize,
            height: style.fontSize,
            viewBox: "0 0 16 16",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "photo"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    strokeWidth: "1",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            d: "M14.5,15.5h-13 c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13C15.5,15.052,15.052,15.5,14.5,15.5z"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("polyline", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            points: "2.5,12.5 9.5,7.5 13.5,11.5 ",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "4.5",
                            cy: "5.5",
                            r: "1.5",
                            "data-color": "color-2",
                            "data-stroke": "none",
                            stroke: "none"
                        })
                    ]
                })
            ]
        })
    });
};
export default Photo;
